/**
 * All storage backends store the
 */
export class AbstractDocumentSnapshotStorageAdapter {
}
//# sourceMappingURL=AbstractDocumentSnapshotStorageAdapter.js.map